var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGemz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ui_icon_gem",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1 {\n        opacity: 0.3;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 501.5,
    y1: 956.75,
    x2: 501.5,
    y2: 94.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009bcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#013887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 503.125,
    y1: 956.75,
    x2: 503.125,
    y2: 461.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0152b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 501.5,
    y1: 461.781,
    x2: 501.5,
    y2: 94.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#167ed9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#03faff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 501.5,
    y1: 461.781,
    x2: 501.5,
    y2: 182.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 501.5,
    y1: 461.781,
    x2: 501.5,
    y2: 218.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#016cd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8adcf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 504,
    y1: 462,
    x2: 504,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ee6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 503.125,
    y1: 461.781,
    x2: 503.125,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07fbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feffff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1008.49,448.682l-467.2,532.584a38.781,38.781,0,0,1-55.56,0L18.537,448.682a40.548,40.548,0,0,1,0-56.6l196.1-254.022c12.162-16.614,30.455-29,49.855-23.7l498.048,0.007c20.958-5.72,40.045,9.45,51.39,28.3l194.561,249.42A40.553,40.553,0,0,1,1008.49,448.682Z",
    transform: "translate(-0.577 -31.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M986.593,423.124L528.708,945.245a38,38,0,0,1-54.453,0L16.371,423.124a39.758,39.758,0,0,1,0-55.482L208.562,118.61c11.919-16.288,29.847-28.427,48.861-23.236l488.121,0.007c20.541-5.608,39.248,9.264,50.367,27.741l190.682,244.52A39.758,39.758,0,0,1,986.593,423.124Z",
    transform: "translate(-0.577 -31.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M782.472,461.786L613.315,849.654l-84.607,95.591a38,38,0,0,1-54.453,0l-85-95.591L223.773,461.786h558.7Z",
    transform: "translate(-0.577 -31.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M782.472,461.786h-558.7S4.556,403.919,5.155,393.147a39.427,39.427,0,0,1,11.215-25.5L208.562,118.61c11.919-16.288,29.847-28.427,48.861-23.236l488.121,0.007c20.541-5.608,39.248,9.264,50.367,27.741l190.682,244.52a39.518,39.518,0,0,1,11.265,28.728C997.62,406.079,782.472,461.786,782.472,461.786Z",
    transform: "translate(-0.577 -31.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M843.422,182.671L986.593,367.642a39.518,39.518,0,0,1,11.265,28.728c-0.238,9.709-215.386,65.416-215.386,65.416Zm-685.792.919L16.371,367.642a39.427,39.427,0,0,0-11.215,25.5c-0.6,10.772,218.618,68.639,218.618,68.639Z",
    transform: "translate(-0.577 -31.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M870.422,218.671L986.593,367.642a39.518,39.518,0,0,1,11.265,28.728c-0.238,9.709-215.386,65.416-215.386,65.416Zm-739.792.919L16.371,367.642a39.427,39.427,0,0,0-11.215,25.5c-0.6,10.772,218.618,68.639,218.618,68.639Z",
    transform: "translate(-0.577 -31.5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.778,94h518.7L588.671,150.174,784,462H224L417.734,149.188Z",
    transform: "translate(-0.577 -31.5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M782.472,461.786h-558.7l278.464-317.8Z",
    transform: "translate(-0.577 -31.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGemz);
export default __webpack_public_path__ + "static/media/icon-gemz.2c23f9e27205c553a1d8150fa3951a09.svg";
export { ForwardRef as ReactComponent };